import { Paper, FormControlLabel, Button, TextField, FormControl, Select, Checkbox, InputLabel, FormGroup} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { updateInfoData, fetchInfo } from "../api/customerapi";
import { useState, useEffect } from "react";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    modalText: {
      marginLeft: theme.spacing(30),
      marginRight: theme.spacing(4),
      width: theme.spacing(120),
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(2),
      alignItems: 'center',
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(14),
        height: theme.spacing(5),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontSize: 10
      },
      textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: "left",
      },
      
  }));

const Info=() => {

    const classes = useStyles();
    const [infoData, setinfoData]=useState({})
    const [infoData2, setinfoData2]=useState("")

    const getInfo = async () => {
        const data = await fetchInfo();
        //const empsplist = data.data.filter((emp) => emp.role !== "Ex-employee");
        //const display=data.data[0].show?"Yes":"No";
        //const custdatalistfromdb= data.data
        setinfoData(data.data[0]);
        //setinfoData2(data.data[1]);
        //setinfoData({...data.data[0], show:display});
        
      };
    useEffect(() => {
    
        getInfo()
       
    
      }, []);

    const handleSubmit =async (e) => {
        e.preventDefault();
        
        const finalinfoData= {...infoData, date:new Date()}
        // const addhotelResponse= await addHotel(finalhotelData);
        //console.log(sData);
        console.log(finalinfoData);
        const addInfoResponse= await updateInfoData(infoData._id,finalinfoData);
        
        if(addInfoResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Info updated");
            window.location = ("/info");
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/home");
        }
        
    }

    return (
        <Paper variant="outlined" className={classes.paper}>
        <form onSubmit={handleSubmit}>
           <TextField variant="standard"  fullWidth label="New Message" InputLabelProps={{ shrink: true }} value={infoData.data} className={classes.textArea} onChange={(e) => setinfoData({...infoData, data:e.target.value})}/>
           
                  <FormControlLabel control={<Checkbox color="primary"/>}  checked={infoData.show?1:0} label="Show Data?" onChange={(e)=> setinfoData({...infoData, show: e.target.checked})}/>
           <FormGroup row className={classes.formgroup}>
                
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href={"/home"} variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                
            </FormGroup>
            </form>
        </Paper>
    )
}

export default Info;